"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var hooks_1 = require("../../../../hooks");
var ConfigProvider_1 = require("../../../../providers/ConfigProvider");
var either_1 = require("../../../../utils/either");
var Utils_1 = require("../Utils");
var PozastaveniCinnostiDialogForm_1 = __importDefault(require("./PozastaveniCinnostiDialogForm"));
var PozastaveniCinnostiForm_1 = __importDefault(require("./PozastaveniCinnostiForm"));
var UpravitPozastaveniCinnosti = function (_a) {
    var _b, _c, _d, _e, _f;
    var initialValues = _a.initialValues, idSubjekt = _a.idSubjekt, handleClose = _a.handleClose, dialogForm = _a.dialogForm, refetch = _a.refetch, znalecValues = _a.znalecValues, tlumocnikValues = _a.tlumocnikValues, isKancelar = _a.isKancelar;
    var _g = ConfigProvider_1.useConfig(), apiUrl = _g.apiUrl, typ = _g.typ;
    var iszrUrl = ConfigProvider_1.useConfig().iszrUrl;
    var postJSON = hooks_1.usePostJSON(apiUrl + "/PozastaveniOpravneni");
    var zmenOsobu = hooks_1.usePostJSON(iszrUrl + "/ZmenOsobu");
    var token = hooks_1.useToken();
    var uzivatel = 'Anonymous';
    if (((_b = token.getDataFromToken()) === null || _b === void 0 ? void 0 : _b.name) || ((_c = token.getDataFromToken()) === null || _c === void 0 ? void 0 : _c.surname)) {
        uzivatel = ((_d = token.getDataFromToken()) === null || _d === void 0 ? void 0 : _d.name) + " " + ((_e = token.getDataFromToken()) === null || _e === void 0 ? void 0 : _e.surname);
    }
    var prepInitialValues = {
        id: initialValues === null || initialValues === void 0 ? void 0 : initialValues.id,
        idZnalec: typ === 'znalec' ? idSubjekt : undefined,
        idTlumocnik: typ === 'tlumocnik' ? idSubjekt : undefined,
        od: initialValues === null || initialValues === void 0 ? void 0 : initialValues.datumOd,
        do: initialValues === null || initialValues === void 0 ? void 0 : initialValues.datumDo,
        idTypPozastaveni: (_f = initialValues === null || initialValues === void 0 ? void 0 : initialValues.typPozastaveni) === null || _f === void 0 ? void 0 : _f.id,
    };
    var onSubmit = function (values, formikHelpers) { return __awaiter(void 0, void 0, void 0, function () {
        var response, zmenOsobuValues, _a, aktualizovatPozastaveni, aktivniPozastaveni, zanikAPreruseni, rosResponse, e_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 9, 10, 11]);
                    formikHelpers.setStatus(undefined);
                    return [4 /*yield*/, postJSON(values)];
                case 1:
                    response = _b.sent();
                    if (!either_1.isRight(response)) return [3 /*break*/, 7];
                    if (!refetch) return [3 /*break*/, 3];
                    return [4 /*yield*/, refetch()];
                case 2:
                    _b.sent();
                    _b.label = 3;
                case 3:
                    if (!!isKancelar) return [3 /*break*/, 6];
                    zmenOsobuValues = void 0;
                    if (!(znalecValues || tlumocnikValues)) return [3 /*break*/, 6];
                    _a = response.value, aktualizovatPozastaveni = _a.aktualizovatPozastaveni, aktivniPozastaveni = _a.aktivniPozastaveni;
                    if (!aktualizovatPozastaveni) return [3 /*break*/, 6];
                    zanikAPreruseni = {
                        pozastaveniOpravneniBool: aktivniPozastaveni,
                        uzivatel: uzivatel,
                    };
                    if (znalecValues) {
                        zmenOsobuValues = Utils_1.znalecValuesForROS(znalecValues, zanikAPreruseni);
                    }
                    if (tlumocnikValues) {
                        zmenOsobuValues = Utils_1.tlumocnikValuesForROS(tlumocnikValues, zanikAPreruseni);
                    }
                    return [4 /*yield*/, zmenOsobu(zmenOsobuValues)];
                case 4:
                    rosResponse = _b.sent();
                    formikHelpers.setSubmitting(false);
                    if (either_1.isRight(rosResponse))
                        formikHelpers.setStatus({ message: 'Referenční údaje byly úspěšně aktualizovány v ROS.', type: 'success' });
                    else
                        formikHelpers.setStatus({ message: rosResponse.value.message, type: 'error' });
                    return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 3000); })];
                case 5:
                    _b.sent();
                    _b.label = 6;
                case 6:
                    handleClose();
                    return [3 /*break*/, 8];
                case 7:
                    formikHelpers.setStatus({ message: response.value.message, type: 'error' });
                    _b.label = 8;
                case 8: return [3 /*break*/, 11];
                case 9:
                    e_1 = _b.sent();
                    console.error(e_1);
                    formikHelpers.setStatus({ message: 'Během úpravy pozastavení činnosti nastala chyba.', type: 'error' });
                    return [3 /*break*/, 11];
                case 10:
                    formikHelpers.setSubmitting(false);
                    return [7 /*endfinally*/];
                case 11: return [2 /*return*/];
            }
        });
    }); };
    return dialogForm ? (react_1.default.createElement(PozastaveniCinnostiDialogForm_1.default, { tlumocnikValues: tlumocnikValues, znalecValues: znalecValues, isKancelar: isKancelar, initialValues: prepInitialValues, onZrusit: handleClose, refetch: refetch })) : (react_1.default.createElement(PozastaveniCinnostiForm_1.default, { initialValues: prepInitialValues, onSubmit: onSubmit, headerText: "Upravit pozastaven\u00ED \u010Dinnosti", onZrusit: handleClose }));
};
UpravitPozastaveniCinnosti.defaultProps = {
    initialValues: undefined,
    dialogForm: false,
    refetch: undefined,
    znalecValues: undefined,
    tlumocnikValues: undefined,
    isKancelar: undefined,
};
exports.default = UpravitPozastaveniCinnosti;
